import * as Service from './service';
import * as Domain from './domain';

export const examSessionModules = [
  Service.examSessionServiceModule,
  Domain.examSessionDomainModule
]
